import { api } from './api';

export interface SetupMFARequest {
  totp_code: string;
}

export interface EnableMFARequest {
  totp_code: string;
}

export interface DisableMFARequest {
  totp_code: string;
}

export interface SetupMFAResponse {
  qr_code_url: string;
  secret: string;
  backup_codes: string[];
}

export interface MFAStatusResponse {
  mfa_enabled: boolean;
}

export const mfaService = {
  async setupMFA(): Promise<SetupMFAResponse> {
    const response = await api.post('/mfa/setup');
    return response.data;
  },

  async enableMFA(data: EnableMFARequest): Promise<{ message: string }> {
    const response = await api.post('/mfa/enable', data);
    return response.data;
  },

  async disableMFA(data: DisableMFARequest): Promise<{ message: string }> {
    const response = await api.post('/mfa/disable', data);
    return response.data;
  },

  async getMFAStatus(): Promise<MFAStatusResponse> {
    const response = await api.get('/mfa/status');
    return response.data;
  },
};
